<template>
<transition
appear
@enter="enter"
>
<div v-if="pageData" class="c-mv2 c-mv2--onlytext">
  <div class="c-mv2__info" :style="{'background': bgColorCode}">
    <h2 :class="{'is-blend': isBlend}" :style="{'color': colorCode}">
      <span v-for="line in pageData.info.title" :key="line">
        <span class="is-line">{{line}}</span>
      </span>
    </h2>
    <div class="is-text">
      <p v-if="pageData.info.text" v-html="pageData.info.text"></p>
      <a v-if="pageData.modal" class="c-btnView" href="#" @click.prevent="openModal">
        <span>VIEW MORE</span>
      </a>
    </div>
  </div>
</div>
</transition>
</template>

<script>
import {gsap, Power3} from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
  data() {
    return {
      pageData: null,
      modal: null,
      isBlend: false,
      colorCode: '',
      bgColorCode: '',
    }
  },
  props: ['name'],
  mounted() {
    // ページデータ
    this.pageData = this.$store.getters.pageData[this.name];
    // モーダル
    this.modal = this.pageData.modal;

    // タイトル文字色設定
    if (this.pageData.info.color) {
      this.colorCode = `${this.pageData.info.color}`;
    } else {
      this.isBlend = true;
    }
    //this.$nextTick(this.once);

    // テキスト背景色設定
    if (this.pageData.info.bgcolor) {
      this.bgColorCode = `${this.pageData.info.bgcolor}`;
    } else {
      this.isInfo = true;
    }
  },
  methods: {
    once(el) {
      // テキスト表示
      const blockText = el.querySelector('.c-mv2__info');
      const lines = blockText.querySelectorAll('.is-line');
      const texts = blockText.querySelector('.is-text');
      let viewTitle = gsap.timeline({
        scrollTrigger: {
          trigger: blockText,
          start: 'top 70%',
          end: 'top 40%',
          once: true,
          toggleActions: 'restart none none none',
          // markers: true,
        }
      });

      viewTitle.fromTo(lines, {
        y: '100%',
      }, {
        duration: 1.0,
        y: '0%',
        ease: Power3.easeOut,
        stagger: 0.1,
      });

      let viewText = gsap.timeline({
        scrollTrigger: {
          trigger: texts,
          start: 'top 70%',
          end: 'top 40%',
          once: true,
          toggleActions: 'restart none none none',
          // markers: true,
        }
      });

      viewText.fromTo(texts.children, {
        opacity: 0,
        y: '20%',
      }, {
        duration: 1.0,
        opacity: 1,
        y: '0%',
        ease: Power3.easeOut,
        stagger: 0,
      });
    },
    openModal() {
      this.$store.commit('setCurrentModal', this.$store.getters.modalData[this.modal]);
      this.$store.commit('setShowModal', true);
    },
    enter(el, done) {
      this.once(el);

      done();
    }
  }
}
</script>